<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Intervenção"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input-autocomplete
                        :repository="repositories.geral.ciap"
                        :request-query-string-params="{sexo_id: data.additionals.paciente.sexoId}"
                        :search-fields="fields"
                        :text-field="(item) => `${item.codigo} - ${item.descricao}`"
                        :validations="validations.ciap"
                        :results-limit= "20"
                        label="CIAP 2"
                        v-model="model.ciap"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.observacao"
                        label="Observações"
                        rows="4"
                        v-model="model.observacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {object, repository} from '@/mixins'

export default {
    computed: {
        validations() {
            return {
                ciap: {required: true},
                observacao: {max: 500},
            }
        },
    },
    created() {
        this.repositories = {
            geral: this.getConectaSusRepository('geral'),
        }
    },
    data: () => ({
        fields: [
            {key: 'geral_ciap.codigo', searchable: true},
            {key: 'geral_ciap.descricao', searchable: true},
        ],
        item: null,
        model: {
            ciap: null,
            observacao: null,
        },
    }),
    methods: {
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()
        },
        edit() {
            this.model = this.clone({
                ciap: this.item.ciap,
                observacao: this.item.observacao,
            })
        },
        store() {
            this.data.model.intervencoes.push({
                ciap: {
                    id: this.model.ciap.id,
                    codigo: this.model.ciap.codigo,
                    descricao: this.model.ciap.descricao,
                },
                observacao: this.model.observacao,
            })
        },
        update() {
            Object.assign(this.item, {
                ciap: {
                    id: this.model.ciap.id,
                    codigo: this.model.ciap.codigo,
                    descricao: this.model.ciap.descricao,
                },
                observacao: this.model.observacao,
            })
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.item) {
                        this.update()
                    } else {
                        this.store()
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        resetForm() {
            this.model.ciap = null
            this.model.observacao = null
        },
    },
    mixins: [object, repository],
    props: {
        data: {required: true, type: Object},
    },
}
</script>